import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_ecomsync_branch_label_hdr_link_RowClass,
  bl_fi_ecomsync_branch_label_hdr_link_RowInterface,
} 
from '../../../dbschema';

export class EcomsyncBranchLabelHdrLinkContainerModel extends BaseContainerModel {
  bl_fi_ecomsync_branch_label_hdr_link: bl_fi_ecomsync_branch_label_hdr_link_RowInterface = new bl_fi_ecomsync_branch_label_hdr_link_RowClass();
}
